import PropTypes from "prop-types";

import { FormRecordPicker } from "components/BaseForm";
import EntityService from "services/Entity";

/**
 * The entity the contact belongs to. From a campaign, only the campaign's
 * entities are offered, as in the legacy add form. It is disabled when the
 * entity is fixed, on edit or by the create preset.
 */
const EntityField = ({ campaignId, display, disabled }) => {
  const fetchEntities = search =>
    EntityService.getEntitiesForFilters({
      ...(search && { search }),
      ...(campaignId && { campaign_ids: [campaignId] }),
    });

  return (
    <FormRecordPicker
      name="entity_id"
      label="Entity"
      required
      fetchOptions={fetchEntities}
      optionsKey={campaignId ? `entity_id:campaign:${campaignId}` : undefined}
      placeholder="Search entities…"
      display={display}
      disabled={disabled}
    />
  );
};

EntityField.propTypes = {
  campaignId: PropTypes.number,
  display: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
  }),
  disabled: PropTypes.bool,
};

export default EntityField;
